import { useHistory, useParams } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { RatingSummary } from '../../app/recipePage/recipePage.types'
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { RatingsSummaryEye, RatingsSummaryStar, RatingStar } from '../../iconRef/recipePageIcons';
import { EventLogsEnum } from '../../utils/events';
import { SeeAllArrow } from '../../utils/iconRefs/recipePageIcons';
import styles from "./recipeDesc.module.css";

const RatingsSummary = ({ ratingsSummary, recipeId, source = "recipePage" }: { ratingsSummary: RatingSummary, recipeId?: string, source?: string }) => {
  const history = useHistory();
  const { recipeId: urlRecipeId } = useParams<{recipeId: string}>();

  const { logRecipeEdit } = useLogRecipeEdit();

  const handleViewAllClick = () => {
    logRecipeEdit(EventLogsEnum.APP_VIEW_REVIEWS, {
      eventData: { recipeId }
    })
    history.push(`/recipe/${urlRecipeId}/reviews`);
  }

  const averageRating = ratingsSummary?.avgRating?.toFixed(1);

  if (ratingsSummary?.avgRating > 3.5 && ratingsSummary?.ratingCount > 10)
    return (
      <Grid className={styles.ratingsContainer}>
        <Grid className={styles.ratingHeader}>
          <Grid className={styles.ratingsHeaderTitle}>
            {source === "recipePage" ? <RatingsSummaryStar /> : <RatingsSummaryEye />}
            <Typography variant="body5">Ratings summary</Typography>
          </Grid>
          {source === "recipePage" ? <Typography className={styles.viewAllRating} onClick={handleViewAllClick} variant="caption4Light">View Reviews <SeeAllArrow /></Typography> : null}
        </Grid>
        <Grid className={styles.ratingsDetails} >
          <Grid className={styles.ratingCount}>
            <RatingStar />
            <Typography variant="body5">{averageRating}</Typography>
            <Typography variant="body2mini">{`(${ratingsSummary?.ratingCount})`}</Typography>
          </Grid>
          {ratingsSummary?.feedbacks?.length > 0 ? <Grid className={styles.ratingFeedbackContainer}>
            {ratingsSummary?.feedbacks?.map((feedback: string) => (
              <Grid className={styles.ratingFeedback}>
                <Typography variant="caption4Light">{feedback}</Typography>
              </Grid>
            ))}
          </Grid> : null}
        </Grid>
      </Grid>
    )

  return null;
}

export default RatingsSummary;